import { useEffect, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import { editAvatarStore } from '../../editAvatar/editAvatar.store';
import '../style.scss';

const AvatarContent = observer(
  ({ setToggleChange }: { setToggleChange: Function }) => {
    const { subscribe } = editAvatarStore;
    const iFrameRef = useRef<any>(null);

    useEffect(() => {
      const iFrame = iFrameRef.current;
      if (iFrame) {
        iFrame.src = 'https://cerebrum.readyplayer.me/avatar?frameApi';
      }
    }, []);

    useEffect(() => {
      const iFrame = iFrameRef.current;
      if (iFrame && iFrame.contentWindow) {
        iFrame.contentWindow.postMessage(
          JSON.stringify({
            target: 'readyplayerme',
            type: 'subscribe',
            eventName: 'v1.avatar.exported',
          }),
          '*',
        );
      }

      window.addEventListener('message', subscribe);
      document.addEventListener('message', subscribe);
      return () => {
        window.removeEventListener('message', subscribe);
        document.removeEventListener('message', subscribe);
      };
    }, []);

    return (
      <iframe
        allow="camera *"
        className="iFrame"
        id="avatar-container"
        ref={iFrameRef}
        title="Ready Player Me"
      />
    );
  },
);

export default AvatarContent;
